'use client';
import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  Navbar as HeroUINavbar,
  NavbarContent,
  NavbarMenu,
  NavbarMenuToggle,
  NavbarBrand,
  NavbarItem,
  NavbarMenuItem,
} from '@heroui/navbar';
import { Button } from '@heroui/button';
import { Link } from '@heroui/link';
import { link as linkStyles } from '@heroui/theme';
import NextLink from 'next/link';
import clsx from 'clsx';

import { siteConfig } from '@/config/site';
import { ThemeSwitch } from '@/components/theme-switch';
import Image from 'next/image';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();

  // Close menu when navigating to a new page
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <HeroUINavbar
      isBordered
      isMenuOpen={isMenuOpen}
      maxWidth="xl"
      position="sticky"
      onMenuOpenChange={setIsMenuOpen}
      classNames={{
        wrapper: 'container container-max',
      }}
    >
      <NavbarContent justify="start">
        <NavbarBrand>
          <NextLink href="/">
            <Image
              src={'/images/logo.svg'}
              alt={''}
              height={35}
              width={130}
              className="block dark:hidden"
            />
            <Image
              src={'/images/logo-dark.svg'}
              alt={''}
              height={35}
              width={130}
              className="hidden dark:block"
            />
          </NextLink>
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent className="hidden gap-12 lg:flex" justify="center">
        {siteConfig.navItems.map((item) => {
          const isActive = pathname === item.href;

          return (
            <NavbarItem key={item.href}>
              <NextLink
                className={clsx(
                  linkStyles({ color: 'foreground' }),
                  'text-sm hover:text-primary',
                  isActive && 'text-primary font-medium'
                )}
                href={item.href}
              >
                {item.label}
              </NextLink>
            </NavbarItem>
          );
        })}
      </NavbarContent>

      <NavbarContent justify="end">
        <NavbarItem>
          <ThemeSwitch />
        </NavbarItem>
        <NavbarMenuToggle
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          className="lg:hidden"
        />
        <NavbarItem className="hidden lg:flex">
          <Button as={Link} color="primary" href={siteConfig.links.becomeAnAgent} radius="full">
            Become An Agent
          </Button>
        </NavbarItem>
      </NavbarContent>

      <NavbarMenu>
        <div className="flex flex-col gap-2 mx-4 mt-2">
          {siteConfig.navMenuItems.map((item, index) => {
            const isActive = pathname === item.href;

            return (
              <NavbarMenuItem key={`${item.href}-${index}`}>
                <Link
                  color={
                    isActive
                      ? 'primary'
                      : index === siteConfig.navMenuItems.length - 1
                        ? 'danger'
                        : 'foreground'
                  }
                  href={item.href}
                  size="md"
                  onClick={() => setIsMenuOpen(false)} // Close menu when clicked
                >
                  {item.label}
                </Link>
              </NavbarMenuItem>
            );
          })}
          <Button
            isExternal
            as={Link}
            color="primary"
            href={siteConfig.links.becomeAnAgent}
            onClick={() => setIsMenuOpen(false)}
          >
            Become An Agent
          </Button>
        </div>
      </NavbarMenu>
    </HeroUINavbar>
  );
};
